import React from 'react';
import '../styles/alertas.css';
import alerta from '../imgs/otros/error.png';
import gusano from '../imgs/otros/gusano recortado.png';

export default function Alertas(props) {
    return (
        <div className="alertas__div--container">
            <div className="alertas__div--cajon-mensaje">
                <img className='alertas__img--alerta' src={alerta} alt="alerta.png"/>
                <h2 className="alertas__h2--mensaje">{props.mensaje}</h2>
                <img className='alertas__img--gusano' src={gusano} alt="gusano.png"/>
            </div>
        </div>
    )
};
